import {Navbar} from '@/components/navbar';
import {PropsWithChildren} from 'react';
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import AppPage from './AppPage';
import {useKeycloak} from './contexts/KeycloakContext';
import {useTitle} from './hooks';
import Home from './pages/Home';
import {Capacity, Demand} from './pages/scenario';

import {Chart as ChartJS, registerables} from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import {Loader} from './components/Loader';
import {default as ConfirmModal, Modal} from './components/modal/Modal';
import Matching from './pages/matching/Matching';
import Forbidden from "@/pages/Forbidden";

ChartJS.register(...registerables, zoomPlugin);

const AuthenticatedRoute: React.FC<PropsWithChildren> = ({children}) => {
    const location = useLocation();
    const {keycloak, isInitialized} = useKeycloak();

    // Attendre l'initialisation de Keycloak
    if (!isInitialized) {
        return <Loader/>; // ou un spinner
    }

    if (!keycloak?.authenticated) {
        return <Navigate to='/login' state={{from: location}} replace/>;
    }

    const roles = keycloak?.realmAccess?.roles || [];
    const hasAccess = roles.includes('epv-access');

    if (!hasAccess) {
        return <Navigate to="/forbidden" replace/>;
    }

    return <>{children}</>;
};

const App = () => {
    useTitle();
    const {isInitialized} = useKeycloak();

    if (!isInitialized) return <Loader/>;

    return (
        <>
            <Navbar/>
            <Routes>
                <Route path='/login' element={<div>Login</div>}/>
                <Route path='/forbidden' element={<Forbidden/>}/>
                <Route element={<AuthenticatedRoute children={<AppPage/>}/>}>
                    <Route path='/' element={<Home/>}/>
                    <Route path='/scenario/'>
                        <Route path='demand' element={<Demand/>}/>
                        <Route path='capacity' element={<Capacity/>}/>
                        <Route path='matching' element={<Matching/>}/>
                    </Route>
                </Route>
                <Route path='*' element={<div>404</div>}/>
            </Routes>
            <ConfirmModal/>
            <Modal/>
        </>
    );
};

export default App;
